import React, { useCallback, useEffect, useState } from 'react'
import { Container, Hero, HeroBody, Title } from 'bloomer'
import styled from 'styled-components'

import Head from '../components/head'
import Layout from '../components/layout'

import withSearch from '../hoc/withSearch'
import { browserWindow } from '../utils'

const utms = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term'
]

const snakeToCamel = string =>
  string.replace(/([-_][a-z])/g, group =>
    group
      .toUpperCase()
      .replace('-', '')
      .replace('_', '')
  )

const CalendlyWidget = styled.div.attrs(({ id }) => ({
  id: id || `calendly`
}))`
  height: 60rem;
  margin: 2rem auto 0 auto;
  min-width: 320px;
  padding: 1rem;
  width: 100%;

  iframe {
    height: 100%;
  }

  @media only screen and (min-width: 32rem) {
    height: 65rem;
  }
`

const Calendly = withSearch(({ search }) => {
  let url = `https://calendly.com/routesupport/route_demo`
  let utm = {}

  const getUTM = param => {
    const parts = param.split('=')
    // console.log('parts: ', parts, snakeToCamel(parts[0]))

    if (utms.includes(parts[0])) {
      utm[snakeToCamel(parts[0])] = parts[1]
    }
  }

  // console.log(search ? 'true' : 'false')

  /* From https://reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node */
  function useWidget() {
    const [widget, setWidget] = useState(null)
    const ref = useCallback(node => {
      // console.log('what am i: ', node, browserWindow.Calendly)
      if (node !== null && browserWindow && browserWindow.Calendly) {
        const calendly = browserWindow.Calendly.initInlineWidget({
          url,
          parentElement: node,
          prefill: { utm }
        })

        setWidget(calendly)
      }
    }, [])

    return [widget, ref]
  }

  useEffect(() => {
    if (search && search.length) {
      search
        .substring(1)
        .split('&')
        .forEach(getUTM)
    }
  })

  const [widget, ref] = useWidget()

  return (
    <CalendlyWidget id={`calendly`} ref={ref}>
      {widget}
    </CalendlyWidget>
  )
})

const Demo = props => (
  <Layout>
    <Head
      author={'Route'}
      title={`Schedule Demo`}
      description={`Book a demo with the route team to check out the product during a live demo session.`}
      keywords={[`route demo`]}
      {...props}
    ></Head>
    <Hero style={{ backgroundColor: '#fbfcfd' }} isSize={'medium'}>
      <HeroBody>
        <Container>
          <Title className={`huge`} isSize={1} hasTextAlign={`centered`}>
            Schedule Your Route Demo
          </Title>
          <Calendly />
        </Container>
      </HeroBody>
    </Hero>
  </Layout>
)

export default Demo
